export default "__VITE_ASSET__6cdf17bb__"